import { MedicalReviewBoardPage as MedicalReviewBoardPageView } from '@/domains/medical-review-board';
import { GetServerSidePropsResult } from 'next';
import { MRB } from '@/types/MRB';
import mrbService from '@/services/mrbService';
import { PageLayout } from '../widgets';

const MedicalReviewBoardPage = ({ mrbs }: { mrbs: MRB[] }): JSX.Element => {
  return (
    <PageLayout>
      <MedicalReviewBoardPageView mrbs={mrbs} />
    </PageLayout>
  );
};

export default MedicalReviewBoardPage;

export async function getServerSideProps(): Promise<
  GetServerSidePropsResult<{ mrbs: MRB[] }>
> {
  const mrbs = await mrbService.getMRBs();

  return { props: { mrbs } };
}
